export class ConsultantConfirmation {
  isUserConsultant?: boolean;
  partyName?: string; // TODO: question removal of this property
  repName?: string; // TODO: question removal of this property

  constructor() {}
}
